import React from 'react';
import { whyUs } from '../data/content';
import './WhyUs.css';

export default function WhyUs() {
  return (
    <section className="why-section">
      <span className="section-eyebrow">Our Promise</span>
      <h2 className="section-title">Why Families<br />Choose Swathi's</h2>

      <div className="why-grid">
        {whyUs.map((item) => {
          const Icon = item.icon;
          return (
            <div className="why-cell" key={item.title}>
              <span className="why-cell-icon">
                {typeof Icon === 'string' ? Icon : <Icon size={18} />}
              </span>
              <div className="why-cell-title">{item.title}</div>
              <div className="why-cell-desc">{item.desc}</div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
